export var KafkaMessageFormat;
(function (KafkaMessageFormat) {
    KafkaMessageFormat["KAFKA_MESSAGE_FORMAT_AVRO"] = "avro";
    KafkaMessageFormat["KAFKA_MESSAGE_FORMAT_JSON"] = "json";
    KafkaMessageFormat["KAFKA_MESSAGE_FORMAT_PROTOBUF"] = "protobuf";
    KafkaMessageFormat["KAFKA_MESSAGE_FORMAT_RAW"] = "raw";
})(KafkaMessageFormat || (KafkaMessageFormat = {}));
